import { render, staticRenderFns } from "./ConfigurationsList.vue?vue&type=template&id=6f8275b4&scoped=true&"
import script from "./ConfigurationsList.vue?vue&type=script&lang=js&"
export * from "./ConfigurationsList.vue?vue&type=script&lang=js&"
import style0 from "./ConfigurationsList.vue?vue&type=style&index=0&id=6f8275b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f8275b4",
  null
  
)

export default component.exports